import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Row, Col,
} from 'reactstrap';

import { CustomButton } from '@shared/buttons';
import useTranslation from '@shared/hooks/useTranslation';
import { Error404Icon } from '@shared/icons';

import '../ErrorStyle.scss';

const PageNotFound = () => {
  const i18n = useTranslation('general');
  const navigate = useNavigate();

  return (
    <div className="error-container">
      <Row className="mb-5">
        <Col>
          <Error404Icon />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <div className="title">{i18n.error.not_found.title}</div>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col>
          <div className="message">{i18n.error.not_found.message}</div>
        </Col>
      </Row>
      <Row>
        <Col>
          <CustomButton
            className="btn-lg go-to-home-btn"
            color="primary"
            onClick={() => navigate('/')}
          >
            {i18n.button.go_home.name}
          </CustomButton>
        </Col>
      </Row>
    </div>
  );
};

export default PageNotFound;
